import React from 'react';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import Section from '../components/Section';

import styles from './Projects.module.scss';

const ProjectsItem = ({ title, coverImage, slug }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.coverWrapper}>
        <Link to={slug.replace(/\/+$/, '')}>
          <div className={`${styles.project} ${styles.coverContent}`}>
            <Img
              fluid={coverImage.childImageSharp.fluid}
              className={styles.image}
            />
            <div className={styles.legend}>{title}</div>
          </div>
        </Link>
      </div>
    </div>
  );
};

const Projects = ({ projects, hideMore, title }) => {
  return (
    <Section light title={title || 'Other albums'}>
      <div className={styles.projects}>
        {projects.map(({ title, coverImage, slug }, index) => (
          <ProjectsItem
            key={index}
            title={title}
            coverImage={coverImage}
            slug={slug}
          />
        ))}
        {!hideMore && (
          <div className={styles.wrapper}>
            <div className={styles.coverWrapper}>
              <Link to="/projects">
                <div className={`${styles.coverContent} ${styles.other}`}>
                  <div>
                    + more
                    <br />
                    albums
                  </div>
                </div>
              </Link>
            </div>
          </div>
        )}
      </div>
    </Section>
  );
};

Projects.defaultProps = {
  projects: []
};

export default Projects;
